<div style="padding: 20px;">
  <div class="table-card">
    <div class="table-header">
      <h2 class="table-title">{{ formatText(subMenu) }}</h2>
      <button mat-flat-button color="primary" class="reset-btn" (click)="ExportTOExcel()" [disabled]="count == 0">Export
        As Excel</button>
    </div>
    <mat-divider style="margin-bottom: 10px;"></mat-divider>
    <table mat-table matSort [dataSource]="dataSource" class="workorder-table">
      <ng-container matColumnDef="GasAccountNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Number</th>
        <td mat-cell *matCellDef="let report">
          {{ report.GasAccountNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="GasMeterID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Meter ID</th>
        <td mat-cell *matCellDef="let report">
          {{ report.GasMeterID }}
        </td>
      </ng-container>
      <ng-container matColumnDef="FirstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
        <td mat-cell *matCellDef="let report">
          {{ report.FirstName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="LastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
        <td mat-cell *matCellDef="let report">
          {{ report.LastName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="HouseNumberSupplement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>House Number</th>
        <td mat-cell *matCellDef="let report">
          {{ report.HouseNumberSupplement }}
        </td>
      </ng-container>
      <ng-container matColumnDef="PEAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
        <td mat-cell *matCellDef="let report">
          {{ report.PEAddress }}
        </td>
      </ng-container>
      <ng-container matColumnDef="City">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
        <td mat-cell *matCellDef="let report">
          {{ report.City }}
        </td>
      </ng-container>
      <ng-container matColumnDef="PostalCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Postal Code</th>
        <td mat-cell *matCellDef="let report">
          {{ report.PostalCode }}
        </td>
      </ng-container>
      <ng-container matColumnDef="CountyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
        <td mat-cell *matCellDef="let report">
          {{ report.CountyName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
        <td mat-cell *matCellDef="let report">
          {{ report.Region }}
        </td>
      </ng-container>
      <ng-container matColumnDef="RateCategory">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rate Category</th>
        <td mat-cell *matCellDef="let report">
          {{ report.RateCategory }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <ng-container *ngIf="count == 0 || dataSource?.data.length === 0">
      <div class="no-records">No records found.</div>
    </ng-container>
    <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
  </div>
</div>